import React, { useState, useEffect} from 'react';

import {
  MdArrowDropUp,
  MdArrowDropDown,
  MdArrowLeft,
} from "react-icons/md";

import { Container, ListContent, ListItem, Test, Descritor, DescritorTitle, Bar } from './styles';
import Accessibility from "../../components/UI/Accessibility";
import Menu from "../../components/UI/Menu";
import ContentBox from "../../components/UI/ContentBox";
import Footer from "../../components/UI/Footer";
import FullScreenLoading from "../../components/UI/FullScreenLoading";
import ReadMoreButton from "../../components/UI/ReadMoreButton"
import Modal from "../../components/UI/Modal";
// import {escola} from './percentual_por_escola.js';

import { images } from "../../constants";
import Banner from '../../components/UI/Banner';
import Grafico from './Grafico';

import useApi from "../../hooks/useApi";



const AvaliacoesGraficos = () => { 
  const [listTest, setListTest] = useState([]);
  const [controlListTest, setControlListTest] = useState(false);
  const [controlListGrafico, setControlListGrafico] = useState(false);
  const [controlFullScreen, setControlFullScreen] = useState(false);
  const [titleGrafico, setTitleGrafico] = useState({text:"",top:"9%"});
  const [dataTest, setDataTest] = useState([]);
  const [dataTestDescritor, setDataTestDescritor] = useState([]);
  const [listBack, setListBack] = useState([]);
  const [modal, setModal] = useState({open:false,title:""});

  const [controlGraphic, setControlGraphic] = useState({
    type: "Escola",
    idReports:[],
    idUnity:"",
  });

  const [loadItem, loadItemInfo] = useApi({
    debounceDelay: 0,
    url: "eaprendi/reportsList",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("load", response);
        let adjustReport = [];
        response.data.forEach((report)=>{
          let pos = adjustReport.findIndex((aReport)=>{
            return aReport.year===report.inicioAplicacao.split("/")[2];
          });
          if(pos>=0){
            adjustReport[pos].list.push(report)
          }
          else{
            adjustReport.push({
              year:report.inicioAplicacao.split("/")[2],
              open:false,
              list:[report],
            });
          }          
        });
        console.log("adjustReport",adjustReport);
        setListTest(adjustReport.sort((reportA,reportB)=>{return reportB.year-reportA.year}));
      }
    },
  });

  const [loadResult, loadResultInfo] = useApi({
    debounceDelay: 0,
    url: "eaprendi/results",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("loadResults", response);
        setDataTest(response.data.dados);
      }
    },
    onError:()=>{}
  });

  const [loadResultDescritor, loadResultDescritorInfo] = useApi({
    debounceDelay: 0,
    url: "eaprendi/results",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("loadResults", response);
        setDataTestDescritor(response.data.dados);
      }
    },
    onError:()=>{}
  });

  useEffect(()=>{
    if(dataTest.length>0){
      switch(controlGraphic.type){
        case "Turma":
          setTitleGrafico({text:`${dataTest[0]["Edição E-Aprendi"]}\n\nEscola:${dataTest[0]?.Escola}`,top:"15%"});//+6% para cada \n\n espaçamento duplo para não ficar grudado
          break;
        case "Questão":
          setTitleGrafico({text:`${dataTest[0]["Edição E-Aprendi"]}\n\nEscola:${dataTest[0]?.Escola} - ${dataTest[0]?.Turma}`,top:"15%"});//+6% para cada \n\n espaçamento duplo para não ficar grudado
          break;
        default:
          setTitleGrafico({text:`${dataTest[0]["Edição E-Aprendi"]}`,top:"9%"});//+6% para cada \n\n espaçamento duplo para não ficar grudado
      }
    }
  },[dataTest,controlGraphic]);

  useEffect(()=>{
    loadItem();
    // eslint-disable-next-line
  },[]);

  useEffect(()=>{
    if(controlListTest){
      setControlListGrafico(false);  
    }
  },[controlListTest]);

  const changeOpenYear = (year) => {
    let newVetor = [];
    listTest.forEach((temp)=>{
      if(temp.year === year){
        temp.open=!temp.open;
      }
      newVetor.push(temp);
    })
    setListTest(newVetor);
  };

  const openResult = (type,idReports) => {
    setListBack([]);
    loadResult({params:{type,idReports:JSON.stringify(idReports)}})
    setControlGraphic({
      type:"Escola",
      idReports
    });
    setControlListTest(false);
    setControlListGrafico(true);
  };

  const clickGrafico = (params) => {
    console.log("click teste",params);
    console.log("controlGraphic",controlGraphic);
    if(controlGraphic.type==="Escola"){
      //carrega o relatorio de Escola

      setListBack([...listBack,{dataTest:[...dataTest],titleGrafico:{...titleGrafico},controlGraphic:{...controlGraphic}}])
      //Armazena as informações antes de entrar na Escola
      
      setControlGraphic({
        ...controlGraphic,
        type:"Turma",
        idUnity:params.value.idUnity,
        unity:params.value.Escola,
      });
      loadResult({params:{type:"turma",idReports:JSON.stringify(controlGraphic.idReports),idUnity:params.value.idUnity}})
      setTitleGrafico({text:`${listTest[0]["Edição E-Aprendi"]}\n\nEscola:`,top:"15%"});
    }
    
    if(controlGraphic.type==="Turma"){ 
      //Verifica se Tem o IdClass se tiver o IDclass carrega com o relatorio da classe caso contrario carrega com o relatorio de Escola

      setListBack([...listBack,{dataTest:[...dataTest],titleGrafico:{...titleGrafico},controlGraphic:{...controlGraphic}}])
      //Armazena as informações antes de entrar na Classe

      setControlGraphic({
        ...controlGraphic,
        type:"Aluno",
        idClass:params.value.idClass,
      });
      loadResult({params:{type:"aluno",idReports:JSON.stringify(controlGraphic.idReports),idUnity:params.value.idUnity,idClass:params.value.idClass}})
      setTitleGrafico({text:`${listTest[0]["Edição E-Aprendi"]}\n\n`,top:"15%"});
    }

    if(controlGraphic.type==="Aluno"){ 
      //Verifica se Tem o IdClass se tiver o IDclass carrega com o relatorio da classe caso contrario carrega com o relatorio de Escola
      loadResultDescritor({params:{type:"aluno_descritor",idReports:JSON.stringify([params.value.idReport]),idUnity:params.value.idUnity,idClass:params.value?.idClass,idStudent:params.value?.idStudent}})
      setModal({open:true,title:<><p>Acertos e Erros por Descritor</p><p>{dataTest[0]?.Escola} - {dataTest[0]?.Turma}</p><p>{params.value.Aluno}</p></>});
    }
    // if(controlGraphic.type==="Turma"){ 
    //   //Verifica se Tem o IdClass se tiver o IDclass carrega com o relatorio da classe caso contrario carrega com o relatorio de Escola

    //   setListBack([...listBack,{dataTest:[...dataTest],titleGrafico:{...titleGrafico},controlGraphic:{...controlGraphic}}])
    //   //Armazena as informações antes de entrar na Classe

    //   setControlGraphic({
    //     ...controlGraphic,
    //     type:"Questão",
    //     idUnity:params.value.idUnity,
    //   });
    //   loadResult({params:{type:"turma_questao",idReports:JSON.stringify(controlGraphic.idReports),idUnity:params.value.idUnity,idClass:params.value?.idClass}})
    //   setTitleGrafico({text:`${listTest[0]["Edição E-Aprendi"]}\n\n`,top:"15%"});
    // }
  };

  const backGraphic = ()=>{
    console.log("List Back",listBack)
    if(listBack.length>0){
      let info = listBack.pop();
      console.log("info voltando grafico",info)
      setControlGraphic({...info.controlGraphic});
      setTitleGrafico({...info.titleGrafico});
      setDataTest([...info.dataTest]);
    }
  };

  const descritor = ()=>{
    if(controlGraphic.type==="Aluno"){ 
      loadResultDescritor({params:{type:"turma_descritor",idReports:JSON.stringify(controlGraphic.idReports),idUnity:controlGraphic.idUnity,idClass:controlGraphic.idClass}})
      setModal({open:true,title:<><p>Acertos e Erros por Descritor</p><p>{dataTest[0]?.Escola} - {dataTest[0]?.Turma}</p></>});
    }
    if(controlGraphic.type==="Turma"){ 
      loadResultDescritor({params:{type:"escola_descritor",idReports:JSON.stringify(controlGraphic.idReports),idUnity:controlGraphic.idUnity}})
      setModal({open:true,title:<><p>Acertos e Erros por Descritor</p><p>Escola:{dataTest[0]?.Escola}</p></>});
    }
    if(controlGraphic.type==="Escola"){ 
      loadResultDescritor({params:{type:"geral_descritor",idReports:JSON.stringify(controlGraphic.idReports)}})
      setModal({open:true,title:`Acertos e Erros por Descritor de Mogi das Cruzes`});
    }
  };

  useEffect(()=>{
    console.log("controlGraphic",controlGraphic);
  },[controlGraphic]);

  useEffect(()=>{
    console.log("List Back",listBack)
  },[listBack]);

  useEffect(()=>{
    console.log("dataTest",dataTest)
  },[dataTest]);

  useEffect(()=>{
    if(modal.open){
      document.getElementsByClassName("ModalTitle")[0].scrollIntoView(true);
    }
  },[modal]);

  return (
    <Container>
      {(loadItemInfo.loading || loadResultInfo.loading) && (
        <FullScreenLoading />
      )}
      {!controlFullScreen && <Accessibility />}
      <Menu />
      <Banner icon={images.iconAvaliacao}>
        GRÁFICOS
      </Banner>
      <ContentBox>
        <ListContent visible={!controlListGrafico}>
          <ListItem key={"ListTest"} onClick={()=>{setControlListTest(!controlListTest)}} visible={true} reduct={0} roundborder={true} selected={controlListTest}>  
            Lista de Avaliações {controlListTest ? <MdArrowDropUp fontSize={36}/>:<MdArrowDropDown fontSize={36}/>}
          </ListItem>
          {listTest.map((year)=>(
            <ListContent key={year.year} visible={controlListTest}>
              <ListItem onClick={()=>{changeOpenYear(year.year)}} visible={controlListTest} reduct={3} roundborder={true} selected={year.open}>  
                {year.year} {year.open ? <MdArrowDropUp fontSize={36}/>:<MdArrowDropDown fontSize={36}/>}
              </ListItem>
              <ListContent visible={year.open}>
                {year.list.map((test)=>(
                  <Test key={test.idRelatorio} reduct={6} visible={year.open}>
                    <div>{test.tituloRelatorio}</div> <ReadMoreButton onClick={()=>{openResult("escola",[test.idRelatorio]);}} text={"abrir resultado"}/>
                  </Test>
                ))}
              </ListContent>
            </ListContent>
           ))}
        </ListContent>
        <ListContent visible={controlListGrafico}>
          <ListItem key={"Grafico"} onClick={()=>{setControlListTest(false);setControlListGrafico(!controlListGrafico);}} visible={true} reduct={0} roundborder={true} selected={controlListGrafico}>  
          <MdArrowLeft fontSize={36}/> Gráfico
          </ListItem>
          <ListItem key={"RenderGrafico"} visible={controlListGrafico} reduct={3} roundborder={false}>  
            { dataTest.length>0?
              <Grafico 
                dataEscola={dataTest} 
                dimension={controlGraphic.type}
                fullscreen={controlFullScreen} 
                closeFullscreen={setControlFullScreen} 
                visible={controlListGrafico} 
                clickOnGrafico={clickGrafico}
                back={listBack.length>0?backGraphic:null}
                descritor={descritor}
                title={titleGrafico}/>:
              <>
                <br/><br/><br/>
                {controlGraphic.type==="Turma"?<>Usuário não tem turmas na escola {controlGraphic.unity} neste relatório.</>:<>Usuário não possui acesso aos dados deste relatório.</>}
                <br/>
                {controlGraphic.type==="Turma"?<>Clique em Voltar Gráfico para consultar outra escola ou selecione o relatório do ano/série para o qual leciona.</>:<>Clique em Voltar Gráfico para consultar outro relatório.</>}
                <br/><br/><br/>
              </>
            }
          </ListItem>
          { dataTest.length>0 && 
            <>
            {listBack.length>0 && <ListItem key={"VoltarGrafico"} visible={controlListGrafico} reduct={3} onClick={()=>{backGraphic();}} roundborder={true} selected={controlListGrafico}>  
              Voltar Gráfico
            </ListItem>}
            <ListItem key={"Descritores"} visible={controlListGrafico} reduct={3} onClick={()=>{descritor();}} roundborder={true} selected={controlListGrafico}>  
              Resultado por Descritor 
              {controlGraphic.type==="Escola" && " de Mogi das Cruzes"}
              {controlGraphic.type==="Turma" && ` (${dataTest[0]?.Escola})`}
              {controlGraphic.type==="Aluno" && ` (${dataTest[0]?.Escola} - ${dataTest[0]?.Turma})`}
            </ListItem>
            <ListItem key={"GraficoFullScreen"} visible={controlListGrafico} reduct={3} onClick={()=>{setControlFullScreen(true);}} roundborder={true} selected={controlListGrafico}>  
              Abrir gráfico em tela cheia 
            </ListItem>
            </>
          }
          { dataTest.length===0 && 
            <>
            {listBack.length>0 && <ListItem key={"VoltarGrafico"} visible={controlListGrafico} reduct={3} onClick={()=>{backGraphic();}} roundborder={true} selected={controlListGrafico}>  
              Voltar Gráfico
            </ListItem>}
            {/* <ListItem key={"Alert"} visible={controlListGrafico} reduct={3} roundborder={false} selected={controlListGrafico}>  
              Gráfico indispónivel
            </ListItem> */}
            </>
          }
        </ListContent>
        <Modal open={modal.open} buttonClose={false}>
          {<DescritorTitle className={"ModalTitle"}>{modal.title}</DescritorTitle>}
          <Descritor>
            {dataTestDescritor.sort(function(a, b){return b.percentual_acertos - a.percentual_acertos}).map((desc)=>
              <div>
                {desc.habilityCode} - {desc.habilityDescription}<br/>
                <Bar porcento={desc.percentual_acertos}>
                  <div className='left'>Acertos({desc.percentual_acertos}%)</div>
                  <div className='right'>Erros({Number.parseFloat(100-desc.percentual_acertos).toFixed(2)}%)</div>
                </Bar>
              </div>
            )}
          </Descritor>
          <ReadMoreButton
            text="Ok"
            type="button"
            onClick={()=>{setModal({open:false,title:""});}}
            disabled={false}
          />
        </Modal>
      </ContentBox>
      <Footer />
    </Container>
  );
}

export default AvaliacoesGraficos;
